








































import { AuthApi, EventTypesApi, ProductsApi, User, UsersApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import {
	filterEntityEventTypes,
	filterEntityEventSubscriptions,
	EventType,
	EventSubscription,
} from '@/models/event-subscription.ts';
@Component
export default class EventSubscriptions extends Vue {
	@Prop(Number)
	private readonly productId?: number;
	@Prop(Object)
	private readonly entity?: any;
	@Prop(String)
	private readonly productType?: string;
	@Prop(String)
	private readonly entityType?: string;
	private eventTypes: EventType[] = [];
	private eventSubscriptions: EventSubscription[] = [];
	private users = [];
	private fields = [
		{ key: 'id', label: 'Event Subscription Id', sortable: true },
		{ key: 'eventTypeId', label: 'Event Type', sortable: true },
		{ key: 'parameters', label: 'Parameters', sortable: true },
		{ key: 'userId', label: 'User', sortable: true },
		{ key: 'channel', label: 'Channel', sortable: true },
	];

	public async load() {
		const product: any = await new ProductsApi().getProductById(parseInt(this.productId, 10), {
			params: {
				include: 'users,eventSubscriptions',
			},
		});
		this.users = product.data.users;
		this.eventSubscriptions = filterEntityEventSubscriptions(
			product.data.eventsubscriptions,
			this.entity.id,
			this.entityType,
		) as EventSubscription[];

		const types: any = await new EventTypesApi().getEventTypesByProductType(this.productType);
		this.eventTypes = filterEntityEventTypes(types.data.data, this.entityType) as EventType[];
	}

	public created() {
		this.load();
	}
}
